import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import css from './BasicModal.module.css';
import { CancelIcon } from '@shared/Icons/CancelIcon';

interface BasicModalProps {
    onClose?: () => void;
    children?: React.ReactNode;
    extraClassName?: string;
    id?: string;
}

export const BasicModal: React.FC<BasicModalProps> = ({
    children,
    extraClassName,
    onClose,
    id,
}) => {
    const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
        const modalContent = event.currentTarget.querySelector(
            `.${css.content}`
        );
        if (modalContent && !modalContent.contains(event.target as Node)) {
            onClose?.();
        }
    };

    const portalContainer =
        document.getElementById('root-cashbuild') || document.body;

    useEffect(() => {
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    return ReactDOM.createPortal(
        <div className={css.overlay} onClick={handleOverlayClick} id={id}>
            <div className={`${css.content} ${extraClassName}`}>
                <div className={css.closeBtn} onClick={onClose}>
                    <CancelIcon width={14} height={14} />
                </div>
                {children}
            </div>
        </div>,
        portalContainer
    );
};
